import React from 'react';
import './Reference.css';

import Icon from '../../../components/Icon/Icon';

const reference = ( props ) => (
	<section id="Reference" className="bg-color-2">
		<h2>Reference</h2>
		<p className="titleNote">
			Need more information? Check here or ask Michael.
		</p>
		<p>
			Check out our YouTube Channel for detailed videos on timesheets, VPN setup, good password practices, and more!
		</p>
		<div className="videos FlipCards">
			{
				props.videos.map( video => {
					const thumbnail = {
						backgroundImage: 'url( assets/images/it/' + video.thumbnail + '.jpg )'
					};
					
					return (
						<div key={ video.id } className="FlipCard">
							<div className="flipper">
								<a href={ video.url } className="video side-1" target="_blank" rel="noopener noreferrer">
									<div className="card-content">
										<Icon icon="arrow" title="View Video" className="video-thumbnail card-thumbnail" style={ thumbnail } />
										<p className="video-title card-text">
											{ video.title }
										</p>
									</div>
									<div className="card-backdrop" />
								</a>
							</div>
						</div>
					);
				})
			}
		</div>
	</section>
);

export default reference;



// WEBPACK FOOTER //
// ./src/pages/IT/Reference/Reference.js